import { createReducer } from '@reduxjs/toolkit';
import {
	API_GET_ALL_SCANNERS,
	API_GET_ALL_SCANNERS_FAIL,
	API_GET_ALL_SCANNERS_SUCCESS,
} from 'actions/scanner';
import { errorHandler, ErrorAction } from 'utils/error';

const initialState = {
	list: [],
    focus: null,
	loading: false,
	exists: null,
	scanner: null,
};

const scanners = createReducer(initialState, {
	/** GET ALL **/
	[API_GET_ALL_SCANNERS]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_SCANNERS_FAIL]: (state, action) => {
		errorHandler('Scanner', ErrorAction.READ, action.error);
		state.loading = false;
	},
	[API_GET_ALL_SCANNERS_SUCCESS]: (state, action) => {
		state.loading = false;
		state.list = action.payload.data;
	},
});

export default scanners;
